import { Button } from 'components';
import { useEffect, useId, useState } from 'react';
import { StyledAdminEditInput } from './styles';
import { AdminConfirmModal } from '../AdminConfirmModal';

interface IAdminEditInputProps {
  children?: React.ReactNode;
  heading: string;
  modalHeading: string;
  onSubmit: (value: number) => void;
  cost: number;
}

export const AdminEditInput = ({ heading, onSubmit, cost, modalHeading }: IAdminEditInputProps) => {
  const formatNumber = (num: number) => {
    const fixed = num.toFixed(10);
    return fixed.replace(/\.?0+$/, '');
  };
  const [amount, setAmount] = useState(formatNumber(cost));
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setAmount(formatNumber(cost));
  }, [cost]);

  const buttonIncrementHandler = () => setAmount((prev) => formatNumber(Number(prev) + 0.0001));
  const buttonDecrementtHandler = () => setAmount((prev) => formatNumber(Number(prev) - 0.0001));
  const changeAmountHandler: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setAmount(event.target.value);
  };

  const submitHandler: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const submitApplyButton = () => {
    onSubmit(Number(amount));
    setShowModal(false);
  };

  const inputId = useId();

  return (
    <StyledAdminEditInput>
      <form className="form" onSubmit={submitHandler}>
        <div className="input-group">
          <label htmlFor={inputId} hidden>
            {heading}
          </label>
          <input
            id={inputId}
            type="text"
            inputMode="decimal"
            className="input"
            value={amount}
            onChange={changeAmountHandler}
          ></input>
          <div className="number-adjust">
            <button
              className="number-adjust-button incr"
              type="button"
              onClick={buttonIncrementHandler}
            >
              <svg
                className="number-adjust-button-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="8"
                viewBox="0 0 16 8"
                fill="none"
              >
                <path
                  d="M15 7L9.30158 2.11564C8.5526 1.47366 7.4474 1.47366 6.69842 2.11564L1 7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <button
              className="number-adjust-button decr"
              type="button"
              onClick={buttonDecrementtHandler}
            >
              <svg
                className="number-adjust-button-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="8"
                viewBox="0 0 16 8"
                fill="none"
              >
                <path
                  d="M15 1L9.30158 5.88436C8.5526 6.52634 7.4474 6.52634 6.69842 5.88436L1 0.999999"
                  strokeWidth="2"
                  strokeLinecap="round"
                  stroke="white"
                />
              </svg>
            </button>
          </div>
        </div>
        <Button type="submit" title={heading} />
      </form>
      {showModal && (
        <AdminConfirmModal
          title={modalHeading}
          onConfirm={submitApplyButton}
          onCancel={closeModal}
          show={showModal}
        />
      )}
    </StyledAdminEditInput>
  );
};
